import React from 'react';
import { Button } from '@mui/material';
import { FileDownload as ExportIcon } from '@mui/icons-material';
import { API_BASE_URL } from '../config';

const ExportButton = ({ exportType = 'daily_inventory', label = 'Export CSV', filters = {} }) => {
  
  const handleExport = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      alert('Please login to export data');
      return;
    }
    
    const params = new URLSearchParams();
    params.append('type', exportType);
    params.append('token', token);
    
    Object.entries(filters).forEach(([key, value]) => {
      if (value) params.append(key, value);
    });
    
    window.open(`${API_BASE_URL}/export_data.php?${params.toString()}`, '_blank');
  };
  
  return (
    <Button variant="outlined" startIcon={<ExportIcon />} onClick={handleExport} sx={{ textTransform: 'none' }}>
      {label}
    </Button>
  );
};

export default ExportButton;